
import React from 'react';
import CompactLayout from '@/components/layout/CompactLayout';
import { KpiLayoutControls } from '@/components/kpi/KpiLayoutControls';
import { useKpiLayout } from '@/hooks/useKpiLayout';
import { kpiData, advancedKpiData } from '@/data/kpi-data';
import KpiCardsGrid from '@/components/kpi/KpiCardsGrid';
import { useKpiCardInteractions } from '@/components/kpi/useKpiCardInteractions';
import '../styles/kpi-animations.css';

const TopKPIs = () => {
  const allKpis = [...kpiData, ...advancedKpiData];
  
  const { 
    visibleKpis, 
    hiddenKpis,
    resetLayout,
    toggleVisibility,
    editMode,
    toggleEditMode
  } = useKpiLayout(allKpis);

  // Import the card interactions with the correct function signature
  const { handleCardClick } = useKpiCardInteractions();
  
  const handleKpiCardClick = (id: string) => {
    handleCardClick(id, editMode);
  };

  return (
    <CompactLayout>
      <div className="p-6 bg-background dark:bg-background min-h-[calc(100vh-4rem)] theme-transition">
        <KpiLayoutControls 
          editMode={editMode}
          toggleEditMode={toggleEditMode}
          resetLayout={resetLayout}
          hiddenKpis={hiddenKpis}
          toggleVisibility={toggleVisibility}
        />
        
        <KpiCardsGrid 
          visibleKpis={visibleKpis}
          editMode={editMode}
          toggleVisibility={toggleVisibility}
          handleCardClick={handleKpiCardClick}
        />
      </div>
    </CompactLayout>
  );
};

export default TopKPIs;
